import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { callStartGateway } from '../../../../call-start/gateways/call-start-gateway'
import { StateGateway } from '../../../../common/gateways/state-gateway'
import { PhoneNumberInputMask } from '../../../../common/input-masks/phone-number.input-mask'
import { PortalGlobals } from '../../../../portalglobals'
import { LicenseApptGateway } from '../../../../user-management/gateways/license-appt-gateway'
import { AddressDB } from '../../../../user-management/models/address'
import { DateTextFieldValidator } from '../../../../validations/date-text-field.validator'
import { EmailAddressTextFieldValidator } from '../../../../validations/email-address-text-field-validator'
import { LengthTextFieldValidator } from '../../../../validations/length-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../../validations/not-blank-generic-field-validator'
import { NumericTextFieldValidator } from '../../../../validations/numeric-text-field-validator'
import { RequiredRadioButtonFieldValidator } from '../../../../validations/required-radio-button-field-validator'
import { ValidatedDateTextField } from '../../../../validations/validated-date-text-field.component'
import { ValidatedSelectOptionModel as State, ValidatedSelectOptionModel } from '../../../../validations/validated-dropdown.component'
import { ValidatedRadioButtonModel } from '../../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../../gateways/enrollment-gateway'
import { EnrollmentCacheData } from '../../../models/EnrollmentCacheData'
import { DrugPlan } from '../../../models/drug-plan'
import { EnrollmentViewModel } from '../../../models/enrollment-view-model'
import { BeneficiaryInfo } from '../../../models/enrollments'
import { GetEnrollmentDataResponse } from '../../../models/get-enrollment-data-response'
import { PlanList } from '../../../models/plan-list'
import { SubmitEnrollmentDataResponse } from './../../../models/submit-enrollment-data-response'
import * as moment from 'moment'
@Component({
    selector: 'PhoneEnrollmentStep4',
    templateUrl: 'phone-enrollment-step4.component.html',
    styleUrls: ['./phone-enrollment.component.scss']
})
export class PhoneEnrollmentStep4Component implements OnInit {
    @Input() enrollment: BeneficiaryInfo
    @Input() disabled: boolean = false

    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef

    periodSelected = ''
    reasonCode: string = ''
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    validatedDate = new ValidatedDateTextField()
    public rblvalidPeriod: ValidatedRadioButtonModel[] = []
    public rblGrp: ValidatedRadioButtonModel[] = []
    public rblPlan: ValidatedRadioButtonModel[] = []
    public rblSameState: ValidatedRadioButtonModel[] = []
    public rblLanguage: ValidatedRadioButtonModel[] = []
    public rblSecondaryCoverage: ValidatedRadioButtonModel[] = []
    public rbllongTerm: ValidatedRadioButtonModel[] = []
    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    public IsRblvalidPeriodYes: boolean
    public IsRblvalidPeriodNo: boolean
    public IsRblGrpYes: boolean
    public IsRblGrpNo: boolean
    public IsRblSameStateNo: boolean
    public IsRblSameStateYes: boolean
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    titleOption: string = ''
    genderOption: string = ''
    notBlankValidator = new NotBlankGenericFieldValidator()
    dateTextFieldValidator = new DateTextFieldValidator()
    numericTextFieldValidator = new NumericTextFieldValidator()
    requiredRadioButtonValidator = new RequiredRadioButtonFieldValidator()
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    phoneNumberInputMask = new PhoneNumberInputMask()
    lengthValidator = new LengthTextFieldValidator(10)
    drugPlanModel = {} as DrugPlan
    states: State[] = [] as State[]
    mailingstates: State[] = [] as State[]
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    public showsubmit: boolean
    public sameAsBusinessAddress = false
    public ispobox: boolean
    planYear: number
    planList: PlanList[] = [] as PlanList[]
    selPlan: string
    AppDate: Date
    EffectiveDate: Date
    IsCovergInfoYes: boolean
    IsCovergInfotext: boolean
    hasError: boolean
    ErrorMessages: any[]
    IsEobYes: boolean
    IsEobNo: boolean
    IsRbllongtermYes: boolean
    IsSameAddress: boolean
    agentUserName: string
    isQtip: boolean
    planstatename: string
    spnIsBeneficiary: string
    spnIsBeneficiary2: string
    spnIsAre: string
    spnYourMediBeneficiary: string
    spnDoDoes: string
    spnIsAreCapt: string
    spnIsBeneficiaryYour: string
    spnIsQualify: string
    spnYouThey: string
    spnYourTheir: string
    spnHasHave: string
    spnIsReside: string
    spnyouheshe: string
    spnyouthey: string
    spnyourhisher: string
    spnyourtheir: string
    spnYourBeneficiaryNew: string
    spnYourenrollee: string
    AgentFullName: string
    dateField: boolean
    eobName: string
    insuranceComapny: string
    public loading: boolean = false
    checkPlanyear: boolean = true
    spnIsBeneficiaryYou: string
    spnyouhimher: string
    spnyouthem: string
    spndodoes: string
    spnyoubenef: string
    spnYouheshe: string
    spnYoutheenrollee: string
    spnnameofMedicare: string
    spntheenrolleeYou: string
    spnYoutheenrollee1: string
    disableEffectiveDate: boolean
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    ShowCurrentYearScript: boolean = false
    CheckGoodStanding: boolean = false
    effectiveDate: string
    public rdlHMO: ValidatedRadioButtonModel[] = []
    public rblRep: ValidatedRadioButtonModel[] = []
    public rblStillProceed: ValidatedRadioButtonModel[] = []
    public IsRdlHMOYes: boolean
    public IsRblRepYes: boolean
    public IsRblRepNo: boolean
    public IsProceedNo: boolean
    spnYouhesheCaps: string
    planName: string
    accessibilityValue: string
    optionaccessibility: ValidatedRadioButtonModel[] = []

    constructor(
        private _enrollementGateway: EnrollmentGateway,
        private _licenseAppGateway: LicenseApptGateway,
        public _global: PortalGlobals,
        private router: Router,
        private _stateGateway: StateGateway,
        private _callStartGateway: callStartGateway
    ) {
        this.spnIsBeneficiary = ' enrollee '
        this.spnIsBeneficiary2 = ' you/he/she '
        this.rblvalidPeriod.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblGrp.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblPlan.push(
            { value: 'SilverScriptChoice', htmlLabel: 'SilverScript Choice' },
            { value: 'SilverScriptPlus', htmlLabel: 'SilverScript Plus' }
        )
        this.rblSameState.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblLanguage.push(
            { value: 'English', htmlLabel: 'English' },
            { value: 'Spanish', htmlLabel: 'Spanish' },
            { value: 'Other', htmlLabel: 'Other' }
        )
        this.rblSecondaryCoverage.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rbllongTerm.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rdlHMO.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblRep.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.rblStillProceed.push({ value: 'Yes', htmlLabel: 'Yes' }, { value: 'No', htmlLabel: 'No' })
        this.optionaccessibility.push(
            { value: '2', htmlLabel: 'Braille' },
            { value: '1', htmlLabel: 'Large Print' },
            { value: '4', htmlLabel: 'Audio CD' }
        )

        if (this._global.selectedPlanYear > this._global.Planyear2024) {
            this.optionaccessibility.push({ value: '8', htmlLabel: 'Data CD' })
        }
        this.accessibilityValue = ''

        this.IsRblGrpYes = false
        this.IsRblGrpNo = false
        this.showsubmit = false
        this.IsCovergInfoYes = false
        this.IsCovergInfotext = false
        this.IsSameAddress = true
        this.IsRdlHMOYes = false
        this.IsRblRepYes = false
        this.IsRblRepNo = false
        this.IsProceedNo = false
        this.planstatename = '(state name)'
        this.ErrorMessages = [] as any[]
        this.disableEffectiveDate = false
    }
    onBlur() {}
    ngOnInit() {
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.planName = this.enrollmentViewModel.PLANTYPENAME
        this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)
        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate([
                '/' + insCo + '/enrollment/phone-enrollment/Step1/' + this.enrollmentCacheData.CALLOGID + '/' + this.enrollmentCacheData.PlanYear
            ])
        }
        if (Number(this._global.selectedPlanYear) === this._global.PreviousPlanYear) {
            this.ShowCurrentYearScript = true

            if (this._global.currentUser.isCallCenterAgent) {
                this.CheckGoodStanding = true
            }
        }
        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                        this.enrollmentViewModel.CALLOGID = this.enrollmentCacheData.CALLOGID
                        this.enrollmentViewModel.RBLBENFE = this.enrollmentCacheData.RBLBENFE
                        if (
                            this.enrollmentViewModel == undefined ||
                            this.enrollmentViewModel.PLANTYPENAME == undefined ||
                            this.enrollmentViewModel.PLANTYPENAME == ''
                        ) {
                            this.loadPlanList()
                        }

                        this.LoadData()
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate([
                    '/' + insCo + '/enrollment/phone-enrollment/Step1/' + this.enrollmentViewModel.CALLOGID + '/' + this.enrollmentViewModel.PLANYEAR
                ])
            }
        } else {
            this.LoadData()
        }
    }

    SalesBenfDetails() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/BeneficiaryDetails/6'])
    }

    onAccessibilityChanges(value) {
        this.accessibilityValue = value
        this.enrollmentViewModel.accessibility = value
    }

    LoadData(): void {
        this.isQtip = false
        this.hasError = false
        if (this._global.currentUser.insuranceCompanyName !== undefined) {
            this.insuranceComapny = this._global.currentUser.insuranceCompanyName
        }
        if (this._global.selectedPlanYear !== undefined) {
            this.planYear = this._global.selectedPlanYear
        }
        if (this._global.currentUser.userProfileName !== undefined) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }
        this.setData()
    }

    setData() {
        //Defualt language to English
        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === null || this.enrollmentViewModel.LANG == '') {
            this.enrollmentViewModel.LANG = 'English'
        }

        if (
            (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) ||
            (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null)
        ) {
            console.log('First name: ' + this.enrollmentViewModel.APPFN)
            this.eobName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
            this.AgentFullName = this.enrollmentViewModel.APPFN + ' ' + this.enrollmentViewModel.APPLN
        } else {
            this.eobName = ' enrollee'
            console.log('First name else: ' + this.eobName)
        }

        if (this.enrollmentViewModel.PLANTYPENAME !== undefined) {
            this.planName = this.enrollmentViewModel.PLANTYPENAME
        }
        this.setScript()

        if (
            this.enrollmentViewModel.RBLLONGTERM !== '' &&
            this.enrollmentViewModel.RBLLONGTERM !== null &&
            this.enrollmentViewModel.RBLLONGTERM !== undefined
        ) {
            this.ShowrbllongtermOptions(this.enrollmentViewModel.RBLLONGTERM)
        }
        if (this.enrollmentViewModel.RBLGRP !== '' && this.enrollmentViewModel.RBLGRP !== null && this.enrollmentViewModel.RBLGRP !== undefined) {
            this.ShowGroupOptionsGRP(this.enrollmentViewModel.RBLGRP)
        }

        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== '' &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== null &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== undefined
        ) {
            this.ShowGroupOptionsHEALTHCOVERAGE(this.enrollmentViewModel.RBLHEALTHCOVERAGE)
        }

        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== undefined &&
            this.enrollmentViewModel.RBLHEALTHCOVERAGE !== null &&
            this.enrollmentViewModel.RBLLIS !== ''
        ) {
            this.ShowOptionsStillProceed(this.enrollmentViewModel.RBLLIS)
        }

        if (this.enrollmentViewModel.OTHCVRG !== '' && this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            this.ShowCoverageInfo(this.enrollmentViewModel.OTHCVRG)
        }

        this.setAccessibility(this.enrollmentViewModel.EOB)
        this.setEOB()

        this.ShowEobEmail(this.enrollmentViewModel.EOB === '3' || this.enrollmentViewModel.EOB === 'EEOB')

        if (this.enrollmentViewModel.RBLHMO !== '' && this.enrollmentViewModel.RBLHMO !== null && this.enrollmentViewModel.RBLHMO !== undefined) {
            this.ShowOptionsHMO(this.enrollmentViewModel.RBLHMO)
        }

        if (
            this.enrollmentViewModel.CALLOGID !== 0 &&
            this.enrollmentViewModel.CALLOGID !== null &&
            this.enrollmentViewModel.CALLOGID !== undefined
        ) {
            this.isQtip = true
        }
        if (this.enrollmentViewModel.EFFDT !== undefined && this.enrollmentViewModel.EFFDT !== null) {
            this.effectiveDate = moment(this.enrollmentViewModel.EFFDT).format('MM/DD/YYYY')
        }
    }
    loadPlanList() {
        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        let planyear
        if (this.enrollmentViewModel.PLANYEAR !== undefined) planyear = this.enrollmentViewModel.PLANYEAR
        else planyear = this._global.selectedPlanYear

        this._enrollementGateway.getPlanList(parseInt(this._global.currentUser.orgId), planyear).subscribe((model: PlanList[]) => {
            this.planList = model
            this.getPlanList(this.planList)

            this.setPlan(this.planList)
        })
    }

    private setPlan(planLst: PlanList[]) {
        if (this.enrollmentViewModel.PLANTYPE !== undefined && this.enrollmentViewModel.PLANTYPE !== '') {
            var selPlan = this.planList.filter((x) => x.PlanTypeName == this.enrollmentViewModel.PLANTYPE)[0]
            this.enrollmentViewModel.PLANTYPENAME = selPlan.PlanName
        }
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }

    ShowrbllongtermOptions(val: any) {
        if (val === 'Yes') {
            this.IsRbllongtermYes = true
        }
        if (val === 'No') {
            this.IsRbllongtermYes = false
        }
        this.enrollmentViewModel.RBLLONGTERM = val
    }
    ShowGroupOptionsGRP(val: any) {
        if (val === 'Yes') {
            this.IsRblGrpYes = true
            this.IsRblGrpNo = false
        }
        if (val === 'No') {
            this.IsRblGrpYes = false
            this.IsRblGrpNo = true
        }
        this.enrollmentViewModel.RBLGRP = val
    }

    ShowCoverageInfo(val: any) {
        if (val === 'Yes') {
            this.IsCovergInfoYes = true
            this.IsCovergInfotext = true
        }
        if (val === 'No') {
            this.IsCovergInfoYes = false
            this.IsCovergInfotext = false
        }

        this.enrollmentViewModel.OTHCVRG = val
    }

    ShowEobEmail(SelEob: boolean) {
        if (SelEob) {
            this.IsEobYes = true
            this.IsEobNo = false
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.IsEobYes = false
            this.IsEobNo = true
            this.enrollmentViewModel.EOB = 'PEOB'
        }
    }

    onBack(): void {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step3'])
    }

    formSubmit(): void {
        this.ErrorMessages = [] as any[]
        this.enrollmentViewModel.AGENTDEX = 'ICALL'
        this.enrollmentViewModel.DEX = 'ICALL'
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '44'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.IsEobYes) {
            this.enrollmentViewModel.LANGFORMAT = 'EEOB'
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.LANGFORMAT = 'PEOB'
            this.enrollmentViewModel.EOB = 'PEOB'
        }

        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }

        // Set  Access
        this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        if (!this.isFormInvalid()) {
            this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe(
                (model: SubmitEnrollmentDataResponse) => {
                    let response = model
                    if (response !== undefined) {
                        if (response.Errors !== undefined && response.Errors.length > 0) {
                            this.hasError = true

                            for (let i = 0; i < response.Errors.length; i++) {
                                this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                            }
                            this.hasError = true
                            this.focusableEleTop.nativeElement.focus()
                        } else {
                            if (response.EnrollmentKey !== undefined && response.EnrollmentKey !== '' && response.EnrollmentKey !== null) {
                                this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey
                                this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                this.loading = false
                                this.router.navigate(['/' + insCo + '/enrollment/phone-enrollment/Step5'])
                            } else {
                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                this.hasError = true
                                this.focusableEleTop.nativeElement.focus()
                            }
                        }
                    } else {
                        this.ErrorMessages.push('Error while submitting data, please try again.')
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                    }
                    this.loading = false
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }
    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }
    validateForm() {}
    isFormInvalid(): boolean {
        this.hasError = false

        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === '') {
            this.ErrorMessages.push('Preferred Language is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.RBLLONGTERM === undefined || this.enrollmentViewModel.RBLLONGTERM === '') {
            this.ErrorMessages.push('Long Term Care Facility is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.RBLLONGTERM === 'Yes') {
            if (this.enrollmentViewModel.LTCFACILITY === undefined || this.enrollmentViewModel.LTCFACILITY === '') {
                this.ErrorMessages.push('Institution Name is required.')
                this.hasError = true
            }
        }
        if (
            this.enrollmentViewModel.LTCFACILITY !== undefined &&
            this.enrollmentViewModel.LTCFACILITY !== '' &&
            this.enrollmentViewModel.LTCFACILITY !== null
        ) {
            let checkltcfacility = this.enrollmentViewModel.LTCFACILITY,
                regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
            let isLtcFacility = regexCovGroupVal.test(checkltcfacility)
            if (!isLtcFacility) {
                this.hasError = true
                this.ErrorMessages.push('Institution Name is invalid')
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                this.ErrorMessages.push('Name of other coverage is required.')
                this.hasError = true
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === 'Yes') {
            if (
                this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                this.enrollmentViewModel.OTHCVRGNAME !== null
            ) {
                let regexCoverageName = /^[A-Za-z\s\-\' ]+$/
                let checkCoverageName = this.enrollmentViewModel.OTHCVRGNAME,
                    regexCoverageNameVal = new RegExp(regexCoverageName)
                let isCovnameValid = regexCoverageNameVal.test(checkCoverageName)
                if (!isCovnameValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Name is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGID !== undefined &&
                this.enrollmentViewModel.OTHCVRGID !== '' &&
                this.enrollmentViewModel.OTHCVRGID !== null
            ) {
                let checkCoverageID = this.enrollmentViewModel.OTHCVRGID,
                    regexCoverageIDVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovIDValid = regexCoverageIDVal.test(checkCoverageID)
                if (!isCovIDValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Id is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                this.enrollmentViewModel.OTHCVRGGRP !== null
            ) {
                let checkCoverageGroup = this.enrollmentViewModel.OTHCVRGGRP,
                    regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovGroupValid = regexCovGroupVal.test(checkCoverageGroup)
                if (!isCovGroupValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Group is invalid')
                }
            }
            if (this.enrollmentViewModel.COBBIN !== undefined && this.enrollmentViewModel.COBBIN !== '' && this.enrollmentViewModel.COBBIN !== null) {
                let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                    regexcheckCOBBINVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isRxBinValid = regexcheckCOBBINVal.test(checkCOBBIN)
                if (!isRxBinValid) {
                    this.hasError = true
                    this.ErrorMessages.push('OtherCoverageBin is invalid')
                }
            }

            if (this.enrollmentViewModel.COBPCN !== undefined && this.enrollmentViewModel.COBPCN !== '' && this.enrollmentViewModel.COBPCN !== null) {
                let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                    regexCOBPCNVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCOBPCNValid = regexCOBPCNVal.test(checkCOBPCN)
                if (!isCOBPCNValid) {
                    this.hasError = true
                    this.ErrorMessages.push('OtherCoveragePcn is invalid')
                }
            }

            if (
                this.enrollmentViewModel.COBEFFDT !== undefined &&
                this.enrollmentViewModel.COBEFFDT !== null &&
                this.enrollmentViewModel.COBTERMDT !== undefined &&
                this.enrollmentViewModel.COBTERMDT !== null
            ) {
                let ed = moment(this.enrollmentViewModel.COBEFFDT).format('MM/DD/YYYY')
                let td = moment(this.enrollmentViewModel.COBTERMDT).format('MM/DD/YYYY')
                if (moment(ed).toDate() > moment(td).toDate()) {
                    this.hasError = true
                    this.ErrorMessages.push('Effective Date for coverage cannot be greater than Termination Date')
                }
            }
        }

        //if (this.enrollmentViewModel.EOB === 'EEOB') {
        if (
            this.enrollmentViewModel.EOB === '3' ||
            this.enrollmentViewModel.EOB === 'EEOB' ||
            this.enrollmentViewModel.EOB === '5' ||
            this.enrollmentViewModel.EOB === '6' ||
            this.enrollmentViewModel.EOB === '7' ||
            this.enrollmentViewModel.EOB === '9'
        ) {
            if (
                this.enrollmentViewModel.APPEMAIL === undefined ||
                this.enrollmentViewModel.APPEMAIL === '' ||
                this.enrollmentViewModel.APPEMAIL === null
            ) {
                //this.ErrorMessages.push('EOB Email is required')
                this.ErrorMessages.push('Email Address is required for Paperless Documents')
                this.hasError = true
            }
        }

        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.APPEMAIL !== undefined &&
            this.enrollmentViewModel.APPEMAIL !== '' &&
            this.enrollmentViewModel.APPEMAIL !== null
        ) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Email Address is invalid.')
            }
        }

        if (
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === undefined ||
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === '' ||
            this.enrollmentViewModel.RBLHEALTHCOVERAGE === null
        ) {
            this.ErrorMessages.push('Please select health coverage')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        // check authorize reprenatative
        if (this.enrollmentViewModel.RBLHMO === undefined || this.enrollmentViewModel.RBLHMO === '' || this.enrollmentViewModel.RBLHMO === null) {
            this.ErrorMessages.push('Please select member advantage plan')
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }

        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    setScript() {
        if (this.enrollmentViewModel.RBLBENFE === 'Yes') {
            this.spnIsBeneficiary = 'you '
            this.spnIsBeneficiary2 = 'you '
            this.spnIsAre = 'are '
            this.spnYourMediBeneficiary = 'your '
            this.spnDoDoes = 'Do '
            this.spnIsAreCapt = 'Are '
            this.spnIsBeneficiaryYour = 'your '
            this.spnIsQualify = 'qualify '
            this.spnYouThey = 'you '
            this.spnYourTheir = 'your '
            this.spnHasHave = 'have '
            this.spnIsReside = ''
            this.spnyouheshe = 'you'
            this.spnyouthey = 'you'
            this.spnyourhisher = 'your'
            this.spnyourtheir = 'your'
            this.spnYourBeneficiaryNew = 'your '
            this.spnIsBeneficiaryYou = 'you'
            this.spnyouhimher = 'you'
            this.spnyouthem = 'you'
            this.spndodoes = 'do'
            this.spnyoubenef = 'you'
            this.spnYouheshe = 'You'
            this.spnYoutheenrollee = 'you'
            this.spnnameofMedicare = 'you'
            this.spnYourenrollee = 'your'
            this.spntheenrolleeYou = 'Your'
            this.spnYoutheenrollee1 = 'you'
            this.spnYouhesheCaps = 'You'
        }
        if (
            this.enrollmentViewModel.RBLBENFE === 'No' &&
            this.AgentFullName !== ' ' &&
            this.AgentFullName !== '' &&
            this.AgentFullName !== 'undefined undefined'
        ) {
            this.spnIsBeneficiary = this.AgentFullName
            this.spnIsBeneficiary2 = ' he/she '
            this.spnIsAre = 'is '
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s '
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies '
            this.spnYouThey = 'they '
            this.spnYourTheir = 'their '
            this.spnHasHave = 'has '
            this.spnIsReside = '(s)'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary '
            this.spnIsBeneficiaryYou = 'the enrollee'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYourenrollee = 'the enrollee'
            this.spntheenrolleeYou = 'The enrollee’s'
            this.spnYoutheenrollee1 = 'the enrollee'
            this.spnYoutheenrollee = this.AgentFullName
            this.spnnameofMedicare = this.AgentFullName
            if (this.enrollmentViewModel.TITLE === 'Mr' || this.enrollmentViewModel.APPGEN === 'M') {
                this.spnyouheshe = 'he'
                this.spnyouthey = 'they'
                this.spnyourhisher = 'his'
                this.spnyourtheir = 'their'

                this.spnyouhimher = 'him'
                this.spnyouthem = 'them'
                this.spnYouheshe = 'he'
                this.spnIsBeneficiary2 = ' he '
                this.spnYouhesheCaps = 'He'
            } else if (
                this.enrollmentViewModel.TITLE === 'Mrs' ||
                this.enrollmentViewModel.TITLE === 'Ms' ||
                this.enrollmentViewModel.APPGEN === 'F'
            ) {
                this.spnyouheshe = 'she'
                this.spnyouthey = 'they'
                this.spnyourhisher = 'her'
                this.spnyourtheir = 'their'

                this.spnyouhimher = 'her'
                this.spnyouthem = 'them'
                this.spnYouheshe = 'she'
                this.spnIsBeneficiary2 = ' she '
                this.spnYouhesheCaps = 'She'
            } else {
                this.spnyouheshe = 'he/she'
                this.spnyouthey = 'they'
                this.spnyourhisher = 'his/her'
                this.spnyourtheir = 'their'

                this.spnyouhimher = 'him/her'
                this.spnyouthem = 'them'
                this.spnYouheshe = 'he/she'
                this.spnYouhesheCaps = 'He/She'
            }
        }
        if (
            this.enrollmentViewModel.RBLBENFE === 'No' &&
            (this.AgentFullName === ' ' || this.AgentFullName === 'undefined undefined' || this.AgentFullName === '')
        ) {
            this.spnIsBeneficiary = ' enrollee’s name'
            this.spnIsBeneficiary2 = '(he/she)'
            this.spnIsAre = 'is'
            this.spnYourMediBeneficiary = 'the Medicare Beneficiary’s'
            this.spnDoDoes = 'Does '
            this.spnIsAreCapt = 'Is '
            this.spnIsBeneficiaryYour = 'the enrollee’s'
            this.spnIsQualify = 'qualifies'
            this.spnYouThey = 'they'
            this.spnYourTheir = 'their'
            this.spnHasHave = 'has'
            this.spnIsReside = '(s)'
            this.spnyouheshe = 'he/she'
            this.spnyouthey = 'they'
            this.spnyourhisher = 'his/her'
            this.spnyourtheir = 'their'

            this.spnIsBeneficiaryYou = 'the enrollee'
            this.spnYourBeneficiaryNew = 'Medicare beneficiary'
            this.spnyouhimher = 'him/her'
            this.spnyouthem = 'them'
            this.spndodoes = 'does'
            this.spnyoubenef = 'the beneficiary'
            this.spnYouheshe = 'he/she'
            this.spnyouthey = 'they'
            this.spnYoutheenrollee = 'the enrollee name'
            this.spnnameofMedicare = 'name of Medicare beneficiary'
            this.spnYourenrollee = 'the enrollee'
            this.spntheenrolleeYou = 'The enrollee’s'
            this.spnYoutheenrollee1 = 'the enrollee'
            this.spnYouhesheCaps = 'He/She'
        }
    }

    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
    ShowGroupOptionsHEALTHCOVERAGE(isgroup: string) {
        if (isgroup === 'Yes') {
            this.IsRblRepYes = true
            this.IsRblRepNo = false
            this.showsubmit = false
        }
        if (isgroup === 'No') {
            this.IsRblRepYes = false
            this.IsRblRepNo = true
            this.showsubmit = true
            this.enrollmentViewModel.RBLLIS = ''
            this.IsProceedNo = false
        }

        this.enrollmentViewModel.RBLHEALTHCOVERAGE = isgroup
    }
    ShowOptionsHMO(ishmo: string) {
        if (ishmo === 'Yes') {
            this.IsRdlHMOYes = true
        }
        if (ishmo === 'No') {
            this.IsRdlHMOYes = false
        }
        this.enrollmentViewModel.RBLHMO = ishmo
    }

    ShowOptionsStillProceed(isStillProceed: string) {
        if (isStillProceed === 'Yes') {
            this.IsProceedNo = false
            this.showsubmit = true
        }
        if (isStillProceed === 'No') {
            this.IsProceedNo = true
            this.showsubmit = false
        }
        this.enrollmentViewModel.RBLLIS = isStillProceed
    }

    setEOB() {
        if (
            this.enrollmentViewModel.EOB != undefined &&
            this.enrollmentViewModel.EOB != null &&
            this.enrollmentViewModel.EOB != '' &&
            (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '3' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                this.enrollmentViewModel.EOB.toLowerCase() === '9')
        ) {
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.EOB = 'PEOB'
        }
    }
    setAccessibility(lAccessibility) {
        if (this.accessibilityValue != '' && this.accessibilityValue != undefined) {
            lAccessibility = this.accessibilityValue
        }
        if (lAccessibility == '1' || lAccessibility == '5') {
            this.enrollmentViewModel.accessibility = '1'
        }
        if (lAccessibility == '2' || lAccessibility == '6') {
            this.enrollmentViewModel.accessibility = '2'
        }
        if (lAccessibility == '4' || lAccessibility == '7') {
            this.enrollmentViewModel.accessibility = '4'
        }
        if (lAccessibility == '8' || lAccessibility == '9') {
            this.enrollmentViewModel.accessibility = '8'
        }
        this.accessibilityValue = this.enrollmentViewModel.accessibility
    }
    SetLanFormat(eob: string, selectedAccessibility: string): string {
        // Set  Access
        this.accessibilityValue = selectedAccessibility
        eob = eob == '3' ? 'EEOB' : eob

        if (eob == 'EEOB' || eob == 'PEOB') {
            if (this.accessibilityValue != undefined && this.accessibilityValue != '') {
                if (this.accessibilityValue == '1') {
                    if (eob == 'EEOB') {
                        eob = '5'
                    } else {
                        eob = '1'
                    }
                }
                if (this.accessibilityValue == '2') {
                    if (eob == 'EEOB') {
                        eob = '6'
                    } else {
                        eob = '2'
                    }
                }
                if (this.accessibilityValue == '4') {
                    if (eob == 'EEOB') {
                        eob = '7'
                    } else {
                        eob = '4'
                    }
                }

                if (this.accessibilityValue == '8') {
                    if (eob == 'EEOB') {
                        eob = '9'
                    } else {
                        eob = '8'
                    }
                }
            }
        }
        return eob
    }
}
